import { render, staticRenderFns } from "./new.profile_reviews.page.vue?vue&type=template&id=5a0d199b&"
import script from "./new.profile_reviews.page.vue?vue&type=script&lang=js&"
export * from "./new.profile_reviews.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports